import { Text, View } from '@react-pdf/renderer'
import { PageFooter } from 'features/reporting/pdfGeneration/components/shared/PageFooter'
import { PageHeader } from 'features/reporting/pdfGeneration/components/shared/PageHeader'
import { ReportPage } from 'features/reporting/pdfGeneration/components/shared/ReportPage'
import { PDFStyles } from 'features/reporting/pdfGeneration/styles/PDFStyles'
import { TOCSection, TOCSectionProps } from 'features/reporting/types'
import { RugReportSectionId } from 'pages/reporting/reports/rug/rugReportData'
import { useRugReportOps } from 'pages/reporting/reports/rug/RugReportProvider'
import React from 'react'

// RUG-specific TOC styling components
const TocSectionItem: React.FC<{
  section: string
  title: string
  page: string
  children?: React.ReactNode
}> = ({ section, title, page, children }) => {
  return (
    <View style={{ marginBottom: 16, fontSize: 10 }}>
      <View
        style={{
          flexDirection: 'row',
          gap: 16,
          marginBottom: children ? 8 : 0,
        }}>
        <Text style={{ minWidth: 32, flexGrow: 0 }}>{section}</Text>
        <Text style={{ flexGrow: 1 }}>{title}</Text>
        <Text style={{ flexGrow: 0 }}>{page}</Text>
      </View>
      {children}
    </View>
  )
}
// TODO: Use sub-items in TOC
// const TocSubItem: React.FC<{
//   title: string
//   page: string
// }> = ({ title, page }) => {
//   return (
//     <View
//       style={{
//         flexDirection: 'row',
//         gap: 16,
//         fontSize: 10,
//         marginBottom: 8,
//       }}>
//       <View style={{ minWidth: 48, flexGrow: 0 }} />
//       <Text style={{ flexGrow: 1 }}>{title}</Text>
//       <Text style={{ flexGrow: 0 }}>{page}</Text>
//     </View>
//   )
// }

const RenderPDF: React.FC<TOCSectionProps> = ({
  entries,
  sectionPages,
  onRender,
}) => {
  const { formData } = useRugReportOps()

  return (
    <ReportPage
      tracker={{
        sectionId: RugReportSectionId.TABLE_OF_CONTENTS,
        onRender,
      }}
      header={<PageHeader title='Table of Contents' />}
      footer={
        <PageFooter
          jobNumber={formData.mainInfo.assetId}
          revisionNumber={formData.revisionMetadata.revisionNumber}
        />
      }
      contentStyle={PDFStyles.content}>
      {/* Column Headers - RUG specific styling */}
      <View
        style={{
          flexDirection: 'row',
          fontSize: 12,
          textDecoration: 'underline',
          fontWeight: 'bold',
          marginBottom: 16,
          paddingHorizontal: 10,
        }}>
        <Text style={{ flexGrow: 1 }}>Section</Text>
        <Text style={{ flexGrow: 0 }}>Page</Text>
      </View>

      {/* Table of Contents Content */}
      <View style={{ margin: 10, padding: 10, flexGrow: 1 }}>
        {entries.map((entry, index) => {
          const sectionNumber = (index + 1).toFixed(1)
          const pageNumber = sectionPages[entry.id] || index + 1

          return (
            <TocSectionItem
              key={entry.id}
              section={sectionNumber}
              title={entry.title}
              page={pageNumber.toString()}
            />
          )
        })}
      </View>
    </ReportPage>
  )
}

export const TableOfContents: TOCSection = {
  id: RugReportSectionId.TABLE_OF_CONTENTS,
  title: 'Table of Contents',
  RenderPDF,
}
